export type LoaderProps = {
  spacing?: number;
};

export default function Loader(props: LoaderProps) {
  let css = "spinner-border";
  css += props.spacing ?? 0 > 0 ? ` m-${props.spacing}` : "";

  return (
    <div className={css} role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  );
}
